const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1'];

const DEFAULT_URLS = {
  admin: 'https://admin.car-pool.app',
  webapp: 'https://webapp.car-pool.app',
  parent: 'https://parent.car-pool.app',
  staff: 'https://staff.car-pool.app',
  parentPreview: 'https://parent-preview.car-pool.app',
  staffPreview: 'https://staff-preview.car-pool.app',
};

const trimUrl = (value) => String(value || '').trim().replace(/\/+$/, '');

const ENV_URLS = {
  admin: trimUrl(process.env.REACT_APP_ADMIN_BASE_URL),
  webapp: trimUrl(process.env.REACT_APP_WEBAPP_BASE_URL),
  parent: trimUrl(process.env.REACT_APP_PARENT_WEB_URL),
  staff: trimUrl(process.env.REACT_APP_STAFF_WEB_URL),
  parentPreview: trimUrl(process.env.REACT_APP_PARENT_PREVIEW_URL),
  staffPreview: trimUrl(process.env.REACT_APP_STAFF_PREVIEW_URL),
};

const deriveHostedUrls = () => {
  if (typeof window === 'undefined') return null;

  const { protocol, hostname } = window.location;

  if (LOCAL_HOSTNAMES.includes(hostname)) {
    return {
      admin: 'http://localhost:3002',
      webapp: 'http://localhost:3001',
      parent: 'http://localhost:3011',
      staff: 'http://localhost:3012',
      parentPreview: 'http://localhost:3011',
      staffPreview: 'http://localhost:3012',
    };
  }

  const variants = [
    {
      adminPrefix: 'admin-staging.',
      webappPrefix: 'webapp-staging.',
      parentPrefix: 'parent-staging.',
      staffPrefix: 'staff-staging.',
      parentPreviewPrefix: 'parent-preview-staging.',
      staffPreviewPrefix: 'staff-preview-staging.',
    },
    {
      adminPrefix: 'admin.',
      webappPrefix: 'webapp.',
      parentPrefix: 'parent.',
      staffPrefix: 'staff.',
      parentPreviewPrefix: 'parent-preview.',
      staffPreviewPrefix: 'staff-preview.',
    },
  ];

  for (const variant of variants) {
    if (!hostname.startsWith(variant.adminPrefix)) continue;

    const suffix = hostname.slice(variant.adminPrefix.length);
    return {
      admin: `${protocol}//${hostname}`,
      webapp: `${protocol}//${variant.webappPrefix}${suffix}`,
      parent: `${protocol}//${variant.parentPrefix}${suffix}`,
      staff: `${protocol}//${variant.staffPrefix}${suffix}`,
      parentPreview: `${protocol}//${variant.parentPreviewPrefix}${suffix}`,
      staffPreview: `${protocol}//${variant.staffPreviewPrefix}${suffix}`,
    };
  }

  return null;
};

export const getHostedAppUrls = () => {
  const derivedUrls = deriveHostedUrls() || {};

  return {
    admin: ENV_URLS.admin || derivedUrls.admin || DEFAULT_URLS.admin,
    webapp: ENV_URLS.webapp || derivedUrls.webapp || DEFAULT_URLS.webapp,
    parent: ENV_URLS.parent || derivedUrls.parent || DEFAULT_URLS.parent,
    staff: ENV_URLS.staff || derivedUrls.staff || DEFAULT_URLS.staff,
    parentPreview: ENV_URLS.parentPreview || derivedUrls.parentPreview || DEFAULT_URLS.parentPreview,
    staffPreview: ENV_URLS.staffPreview || derivedUrls.staffPreview || DEFAULT_URLS.staffPreview,
  };
};
